import { Sidebar, TextArea } from 'components/common';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import { Formik, Form } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ExpensesCanceledProps {
  noteId: number;
  handleStatusChange: (status: number) => void;
  toggleRefresh: () => void;
  toggleRefreshDT?: () => void;
}

const ExpensesCanceled: FC<SideBarProps<ExpensesCanceledProps>> = ({
  sidebar,
  setSidebarWidth,
  sidebarWidth,
  params,
}) => {
  const { t } = useTranslation();
  const { closeSidebar } = useSidebarManager();
  return (
    <Sidebar
      size="m"
      type="secondary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
    >
      <div id="cancel_modal" className="minthr-h-100">
        <Formik
          initialValues={{}}
          onSubmit={() => {
            params.handleStatusChange(5);
            closeSidebar(ExpensesCanceled);
          }}
        >
          <Form
            // action="@Url.Action("ChangeStatus", "Expenses")" data-ajax-success="onsuccessStatus"
            //   data-ajax="true" data-ajax-method="POST"
            //   enctype="multipart/form-data"
            className="w-100"
          >
            <div className="minthr-flex minthr-flex-items-center minthr-pb-2 minthr-mb-3 minthr-border-b minthr-border-b-3">
              <h3>{t('expenses.cancel.model.title')}</h3>
              <button
                className="minthr-sidebar-close"
                type="button"
                onClick={() => closeSidebar(ExpensesCanceled)}
              >
                <img src="/icons/close.svg" alt="close icon" />
              </button>
            </div>
            {/* <div asp-validation-summary="ModelOnly"></div>
            <input hidden asp-for="Status" value="@NoteStatus.Canceled" /> */}
            <div className="row g-0 minthr-mb-5">
              <div className="col-sm-12">
                {/* @Html.FullTextArea_v2(x=>x.Comment,@SharedLocalizer.Get("Commentaire")) */}
                <TextArea label={t('comment')} name="comment" />
              </div>
            </div>
            {/* <input value="@Model.Id" asp-for="Id" hidden /> */}
            <div className="minthr-sidebar-footer minthr-box-shadow minthr-flex minthr-flex-items-center minthr-flex-items-end minthr-py-4 minthr-mx-n5 minthr-px-6 minthr-mt-auto">
              <button
                type="button"
                className="minthr-btn minthr-btn-outline minthr-btn-primary minthr-ml-auto minthr-sidebar-close"
              >
                {t('cancel')}
              </button>
              <button
                type="submit"
                className="minthr-btn minthr-btn-primary minthr-ml-6 detail-depense-sidebar-open"
              >
                {t('submit')}
              </button>
            </div>
          </Form>
        </Formik>
      </div>
    </Sidebar>
  );
};

export default ExpensesCanceled;
